/**
 * Live Blog components.
 */
import domContentLoaded from 'utils/domContentLoaded';
import reactComponentManager from 'utils/reactComponentManager';
import LiveBlog from 'components/live-blog/index.tsx';

import 'scss/live-blog/index.scss';

domContentLoaded(() => {
  reactComponentManager({
    LiveBlog,
  });
});

if (module.hot) {
  module.hot.accept();

  reactComponentManager({
    LiveBlog,
  });
}
